import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getSEOData } from '../data/seoData';

const PAGE_TITLES = {
  '/': 'Mzansi Save',
  '/about-us': 'About Us',
  '/contact-us': 'Contact Us', 
  '/graduate-agents': 'Graduate Agents',
  '/how-it-works': 'How It Works',
  '/resources': 'News & Updates',
  '/constitution': 'Constitution',
  '/termsofuse': 'Terms of Use',
  '/privacy': 'Privacy Policy'
};

const usePageTitle = () => {
  const location = useLocation();
  
  useEffect(() => {
    const seoData = getSEOData(location.pathname);
    const title = seoData.title || PAGE_TITLES[location.pathname] || 'Mzansi Save';
    
    document.title = title.includes('Mzansi Save') ? title : `${title} | Mzansi Save`;
  }, [location.pathname]);
  
  return getSEOData(location.pathname);
};

export default usePageTitle;
